import React, { Fragment, useEffect, useState } from "react";
import styles from "./scss/notelist.module.scss";
import notesimg from "../../../styles/images/notessvg.svg";
import { URButton } from "../../../shared/widgets/button";
import { URInput } from "../../../shared/widgets/input";
import moment from "moment";
import CreateNote from "./notecreate";
import { chatwindowDetails, initialStateModel, LoginState, rightSidePanelDetails } from "../../../models/model";
//import store from "../../../context/store/store";
import _ from "lodash";
import { useSelector } from "react-redux";
import NotFound from "../../../styles/images/empty_states/notes_empty_state.svg";
import NoContent from "../../../shared/widgets/noContent";
import { chatSideWindow } from "../../../base/eventService/eventApiService";
import { URNotesSkeleton } from "../../../shared/skeletonLoading/notesSkeleton";
import { Dropdown, Menu } from "antd";
import { HighlightInner } from "../../contacts/rightsidebar/highlight";
type NotesPageState = {
  searchNotes: any;
  filterKey: string;
  isSearch: any;
  noteList: any;
  AuthorList: any;
  AuthorFilterstore: any;
  isCalender: boolean;
  tempNoteList: any;
  isVisible:boolean;
  searchText:string;
 

}
type notesProps = {
  notesLists: any
}
export default function NotesListsRight({ notesLists }: notesProps) {
  const {userdetails}: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const chatWindowDetail: chatwindowDetails = useSelector((state: initialStateModel) =>
    state.chatWindowReducer);
  const { chatWindowDetails } = chatWindowDetail;
  const rightSideLink: rightSidePanelDetails = useSelector((state: initialStateModel) =>
    state.chatRightSidePanelReducer);

  const [notesList, setnotesList] = useState<NotesPageState>({
    searchNotes: notesLists,
    filterKey: "All", isSearch: [], AuthorList: [], tempNoteList: notesLists,
    AuthorFilterstore: [],
    noteList: notesLists, isCalender: false,isVisible:false,searchText:""
  });
  useEffect(() => {
    setnotesList({ ...notesList, searchNotes: notesLists, noteList: notesLists, AuthorFilterstore: notesLists,tempNoteList: notesLists });

  }, [notesLists?.length]);

  const [openNote, setOpenNote] = useState(false);

  const onclose = () => {
    setOpenNote(false);
  };
  useEffect(() => {
    let arr: any = [];
    if (chatWindowDetails.team_id) {
      arr = [...chatWindowDetails.teammembersdetails]
    } else {
      arr = [userdetails, chatWindowDetails]
    }
    setnotesList({
      ...notesList, isSearch: arr,
      AuthorList: arr
    });
  }, [chatWindowDetails]);


  const searchnotesinList = (e: any) => {
    let searchText = e.target.value.toLowerCase();
    let response: any = _.filter(notesList?.tempNoteList, function (data: any) {
      let noteName = data?.summary || "";
      let Datesearch = moment(new Date(parseInt(data?.lastModified) * 1000)).format("ddd, MMM Do YYYY") || '';
      return (((noteName)?.toLowerCase())?.includes(searchText) ||
        (Datesearch?.toString())?.toLowerCase()?.includes(searchText));

    });
    setnotesList({ ...notesList, searchNotes: response ,searchText:e.target.value});
  };

  const searchMember = (e: any) => {

    let searchText = e.target.value.toLowerCase();
    let response = _.filter(notesList.isSearch, ((list: any) => {

      let caller_id = list?.caller_id || "";

      return ((caller_id?.toLowerCase()).includes(searchText));
    }));
    setnotesList({ ...notesList, AuthorList: response,searchText:searchText });
  };


  const AuthorFilter = (list: any) => {
    const response: any = _.filter(notesList.noteList, ((item) => {
      return item?.ownerId === list.sip_login_id.toString();
    }));
    setnotesList({ ...notesList, searchNotes: response,isCalender: false, AuthorFilterstore: response, filterKey: "All",isVisible:false });

  };
  const openCalender = (key: any, list?: any) => {
    if (key === "calender") {
      setnotesList({ ...notesList, isCalender: true, filterKey: "calender" ,isVisible:false});
    } else if (key === "All") {
      setnotesList({ ...notesList, searchNotes: notesList.noteList, isCalender: false, tempNoteList: notesList.noteList,filterKey: "All",isVisible:false  });
    } else {

      let date = new Date();
      let formatKey: any = key === "Today" ? moment(date).format('YYYY/MM/DD') : moment(date).subtract(1, 'day').format('YYYY/MM/DD');

      let response = _.filter(notesList.noteList, ((data: any) => {
        let notesDate = moment(new Date(parseInt(data.lastModified))).format('YYYY/MM/DD');
        return notesDate === formatKey;
      }));

      setnotesList({ ...notesList, filterKey: key, searchNotes: response, tempNoteList: response ,isVisible:false});
    }
  };

  const showNote = (data: any) => {
    chatSideWindow(true, "editnotes", data);
  };
  const showNotes = (data: any) => {
    chatSideWindow(true, "notes", "");
  };

  const handleChange = (flag:boolean)=>{
    setnotesList({ ...notesList,isVisible: flag});
  }
  
  const menu = (
    <Menu className="rightdropactions2" >
      <Menu.Item className={notesList.filterKey === 'All' ?
        "active" : ''}>
        <div className={`notesdd ${styles.dropsdowns}`} >
          <div className={`searchnotes ${styles.innerlayerssearch}`}>
            <URInput placeHolder="Search" className="leftbarsearch notes" onChange={(e: any) => searchMember(e)} />
          </div>
          <div className="innerlayers scroller">
           {notesList?.searchText === "" && <> <h4>Date Created</h4>
            <ul className="datacreate">
            <li  key={'All'} onClick={() => openCalender("All")}>All</li>
              <li key={'Today'} onClick={() => openCalender("Today")}>Today</li>
              <li key={'Yesterday'} onClick={() => openCalender("Yesterday")}>Yesterday</li>
          {/*     <li key={'calender'} onClick={() => openCalender("calender")}>Calender</li> */}

            </ul>
            <h4>Author</h4></>}
            <ul   >
            {notesList?.AuthorList?.map((man:any,i:any)=>{
                           return(
                            <Fragment
                    key={i}>
                               <li onClick={()=>AuthorFilter(man)}>{man?.caller_id}</li>
                             </Fragment>
                            
                           );
                            
                         })
                      }
            </ul>

          </div>
        </div>

      </Menu.Item>


    </Menu>
  );
  let teamMemberOnly = chatWindowDetails.team_id &&
  chatWindowDetails?.team_members ? _.includes(chatWindowDetails?.team_members, userdetails.sip_login_id) : '';
  
  
  return (
    <>



      <div
        className={`fadeIn
    ${styles.notesmain}`}>

        <div
          className={styles.rightbartop}>

          {((!openNote && teamMemberOnly) || chatWindowDetails.sip_login_id ) &&
            <div
              className={styles.notesnewbtn}>
              <span className={styles.titleText}>Note</span>
              <URButton
                onClick={showNotes}
                className={`${"rightnewtask"} ${chatWindowDetails?.is_blocked === 1 && 'blockdisabled'}`}
                name="New Note"
              />

            </div>}

          <div
            className={styles.notessearchbar}>

            {!openNote &&
              <><div
                className={styles.lefts}>

                <URInput
                  placeHolder="Search"
                  className="rightbarsearch"
                  onChange={searchnotesinList}
                />

              </div>


                <div
                  className={styles.rights}>

                  <Dropdown
                    className="popss2"
                    overlay={menu}
                    trigger={['click']}
                    visible={notesList.isVisible}
                    onVisibleChange={handleChange}
                    placement="bottomRight">

                    <p>{notesList.filterKey.length
                      > 0 ?

                      notesList.filterKey : "All"}

                      <span
                        className={`icon_down-arrow menudroprotate`}></span>

                    </p>


                  </Dropdown>


                </div>


              </>}

          </div>

        </div>

        {(rightSideLink.isNotes === false && !openNote
          && rightSideLink.notesListDetails.length ===
          0) ?

          [1, 2, 3, 4, 5, 6].map((data: any) => (

            <div
              className={styles.skeletonSec}
              key={data}>

              <URNotesSkeleton
                key={data} />

            </div>

          ))

          : (!openNote && notesList.searchNotes.length ===
            0 && !rightSideLink.isNotesLoader) ?

            <NoContent
              image={NotFound}

              title={"Worktual Notes"}

              description={<>A personal space for you to jot down ideas, lists, memos -you name it.</>}
            /> : !openNote && !rightSideLink.isNotesLoader &&
            rightSideLink.isNotes &&

            <div
              className={styles.rightbarbottom}>

              {notesList.searchNotes &&
                notesList.searchNotes.length >
                0 ?

                notesList.searchNotes.map((notesdata: any, i: any) => (

                  <Fragment
                    key={i}>

                    <div
                      className={styles.noteslist}
                      onClick={(e: any) => showNote(notesdata)}>

                      <div
                        className={styles.noteshort}>
                        <p>
                          {/* <img src={notesimg} alt=""/> */}
                          <HighlightInner content={notesdata?.summary}
                        searchedData={notesList?.searchText}></HighlightInner> </p>
                        <h6>Created on
                          { " "+moment(new
                            Date(parseInt(notesdata.lastModified)))

                            .format("ddd, MMM Do YYYY")}</h6>

                      </div>

                    </div>

                  </Fragment>

                )) : null

              }


            </div>}

        {openNote &&
          <CreateNote
            onClose={onclose} />}

      </div>



    </>

  );
};

